import React, { ReactNode } from 'react';

import { SelectItem } from '@justgiving/select';
import { FieldArrayRenderProps } from 'formik';

import { useNotNullableContext } from '../../../hooks';
import { TimelineImage } from '../../Timeline/timelineTypes';
import { TimePeriod } from './Helpers/TimeHelpers';
import { ManualFitnessEntryFormValues } from './ManualFitnessEntryForm';
import { UnitOfMeasure } from './Helpers/ConversionHelpers';
import { FitnessApplicationActivityType } from '../../../../types/__generated__';

export interface ManualFitnessEntryFormContext {
  touched: {
    activityDateTimeTouched?: boolean;
    durationTouched?: boolean;
    distanceTouched?: boolean;
    elevationTouched?: boolean;
  };
  errors: {
    activityDateTimeError?: string;
    durationError?: string;
    distanceError?: string;
    elevationError?: string;
  };
  values: ManualFitnessEntryFormValues;
  callbacks: {
    onImageUploaded: (
      image: TimelineImage,
      values: ManualFitnessEntryFormValues,
      arrayHelpers: FieldArrayRenderProps,
    ) => void;
    onImageUploadedFailure: (
      image: TimelineImage,
      values: ManualFitnessEntryFormValues,
      arrayHelpers: FieldArrayRenderProps,
    ) => void;
  };
  activityValues: {
    distanceUnits: Array<
      SelectItem & {
        value: UnitOfMeasure;
      }
    >;
    elevationUnits: Array<
      SelectItem & {
        value: UnitOfMeasure;
      }
    >;
    activityTypes: Array<
      SelectItem & {
        value: FitnessApplicationActivityType;
      }
    >;
    timePeriods: Array<
      SelectItem & {
        value: TimePeriod;
      }
    >;
    now: Date;
  };
}

export const ManualFitnessEntryFormCtx = React.createContext<ManualFitnessEntryFormContext | null>(
  null,
);

export const useManualFitnessEntryFormContext = () =>
  useNotNullableContext(ManualFitnessEntryFormCtx);

export function ManualFitnessEntryFormContext({
  children,
  ...rest
}: { children: ReactNode } & ManualFitnessEntryFormContext) {
  return (
    <ManualFitnessEntryFormCtx.Provider value={rest}>
      {children}
    </ManualFitnessEntryFormCtx.Provider>
  );
}
